import axios from 'axios';

// const prefix = 'http://evaluate.test/index.php';
const prefix = 'https://evalapi.qzhip.com/index.php';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: prefix + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
  return axios({
      method: method,
      url: prefix + url,
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        //    token: localStorage.getItem('logintoken')
           token: localStorage.getItem("userToken")
      },
      data: params,
      traditional: true,
      transformRequest: [
          function(data) {
              let ret = ''
              for (let it in data) {
                  ret +=
                      encodeURIComponent(it) +
                      '=' +
                      encodeURIComponent(data[it]) +
                      '&'
              }
              return ret
          }
      ]
  }).then(res => res.data);
};

export {
    loginreq,
    req
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js